module.exports = __webpack_public_path__ + "static/media/page-02.6211d322.png";